import { useCallback, useMemo } from 'react';

import { UserType } from '@enums/index';

import {
    useLazyGetMenteeExperienceQuery,
    useLazyGetMentorExperienceQuery,
} from '../api/professionalInfo';
import { ExperiencesResponse } from '../types';

interface GetExperienceProps {
    userType: UserType;
}

export default function useGetExperience({ userType }: GetExperienceProps) {
    const [
        getMentorExperiences,
        { data: mentorExperiences, isLoading: isMentorExperiencesLoading },
    ] = useLazyGetMentorExperienceQuery();

    const [
        getMenteeExperiences,
        { data: menteeExperiences, isLoading: isMenteeExperiencesLoading },
    ] = useLazyGetMenteeExperienceQuery();

    const isLoading = useMemo(
        () => isMentorExperiencesLoading || isMenteeExperiencesLoading,
        [isMentorExperiencesLoading, isMenteeExperiencesLoading]
    );

    const experiences = useMemo(
        () => mentorExperiences || menteeExperiences,
        [mentorExperiences, menteeExperiences]
    );

    const getExperiences = useCallback(
        (username: string) => {
            let experiencesData: ExperiencesResponse;
            switch (userType) {
                case UserType.Mentor:
                    getMentorExperiences({ username });
                    break;
                case UserType.Mentee:
                    getMenteeExperiences({ username });
                    break;
                default:
                    break;
            }
            return experiencesData!;
        },
        [getMentorExperiences, getMenteeExperiences, userType]
    );
    return {
        getExperiences,
        isLoading,
        experiences,
    };
}
